import * as React from "react";
import { TabsContent } from "@/components/ui/tabs";
import type { MachineDetail } from "@/features/lines/hooks";
import { BasicDataTab } from "../BasicDataTab";
import { OperationTab } from "../OperationTab";
import { AlarmsTab } from "../AlarmsTab";
import { SensorsTab } from "../SensorsTab";
import { ParametersTab } from "../ParametersTab";
import { CompatibilitiesTab } from "../CompatibilitiesTab";
import { AdvancedActionsTab } from "../AdvancedActionsTab";
import type { MachineChangeEvent, SidebarContext, SidebarMode } from "./types";

interface TabsPanesProps {
  machine: MachineDetail | undefined;
  lineId: string;
  effectiveMode: SidebarMode;
  context: SidebarContext;
  showConfigTabs: boolean;
  isDraft?: boolean;
  onMachineChange: (event: MachineChangeEvent) => void;
  markDirty: (tab: string, dirty: boolean) => void;
}

export function TabsPanes({
  machine,
  lineId,
  effectiveMode,
  context,
  showConfigTabs,
  isDraft = false,
  onMachineChange,
  markDirty,
}: TabsPanesProps): React.ReactElement {
  return (
    <div className="min-h-0 flex-1 overflow-y-auto p-4">
      <TabsContent value="basic">
        <BasicDataTab
          machine={machine}
          lineId={lineId}
          mode={effectiveMode}
          context={context}
          onMachineChange={onMachineChange}
          onDirtyChange={(d) => markDirty("basic", d)}
        />
      </TabsContent>
      {showConfigTabs ? (
        <TabsContent value="parameters">
          {machine ? (
            <ParametersTab
              machine={machine}
              lineId={lineId}
              mode={effectiveMode}
              onDirtyChange={(d) => markDirty("parameters", d)}
            />
          ) : null}
        </TabsContent>
      ) : null}
      <TabsContent value="sensors">
        {machine ? (
          <SensorsTab machine={machine} lineId={lineId} mode={effectiveMode} />
        ) : (
          <p className="text-sm text-muted-foreground">
            Salve os dados básicos primeiro para gerenciar sensores.
          </p>
        )}
      </TabsContent>
      {showConfigTabs ? (
        <TabsContent value="compatibilities">
          {machine ? (
            <CompatibilitiesTab
              machine={machine}
              lineId={lineId}
              mode={effectiveMode}
              onDirtyChange={(d) => markDirty("compatibilities", d)}
            />
          ) : null}
        </TabsContent>
      ) : null}
      {}
      {!isDraft ? (
        <TabsContent value="alarms">
          {machine ? (
            <AlarmsTab machine={machine} lineId={lineId} />
          ) : (
            <p className="text-sm text-muted-foreground">
              Salve os dados básicos primeiro para ver alarmes.
            </p>
          )}
        </TabsContent>
      ) : null}
      {!isDraft ? (
        <TabsContent value="operation">
          {machine ? (
            <OperationTab machine={machine} lineId={lineId} />
          ) : (
            <p className="text-sm text-muted-foreground">
              Sem dados operacionais até o primeiro save.
            </p>
          )}
        </TabsContent>
      ) : null}
      {showConfigTabs ? (
        <TabsContent value="advanced">
          {machine ? (
            <AdvancedActionsTab
              machine={machine}
              lineId={lineId}
              mode={effectiveMode}
              onMachineChange={onMachineChange}
            />
          ) : null}
        </TabsContent>
      ) : null}
    </div>
  );
}
